import Button, { ButtonVariant } from './Button';

export interface ShareButtonProps {
  className?: string;
  onClick: () => void;
}

export default function ShareButton({ className, onClick }: ShareButtonProps) {
  return (
    <Button variant={ButtonVariant.WHITE} className={className} onClick={onClick}>
      <svg width="12.39" height="12.39" viewBox="0 0 12.39 12.39">
        <path
          d="M12.39,34.655A2.654,2.654,0,0,1,7.733,36.4L5.252,37.639a2.689,2.689,0,0,1,0,1.112l2.481,1.242a2.637,2.637,0,1,1-.595,1.186L4.657,39.937a2.655,2.655,0,1,1,0-3.485l2.481-1.242a2.655,2.655,0,1,1,5.252-.556ZM2.655,39.522a1.327,1.327,0,1,0-1.327-1.327A1.327,1.327,0,0,0,2.655,39.522Zm8.407-4.868a1.327,1.327,0,1,0-1.327,1.327,1.327,1.327,0,0,0,1.327-1.327ZM9.735,43.063a1.327,1.327,0,1,0-1.328-1.327A1.327,1.327,0,0,0,9.735,43.063Z"
          transform="translate(0 -32)"
        />
      </svg>
      Share
    </Button>
  );
}
